/**
 * /dashboard/accounting/accounts — Chart of Accounts list (G_ACC2).
 *
 * Renders all 26 seeded system accounts (ordered by code ASC, grouped by
 * type) plus any custom sub-accounts added by the HR-admin/accountant.
 * System accounts expose no edit/archive affordance. Custom accounts
 * expose row-level Edit (inline sheet) and Archive (confirm dialog).
 *
 * Role-gate: accountingRole = company_admin | hr_manager | accountant.
 * Feature-gate: RequireFeature("accounting") — enforced by the backend;
 * the frontend wraps the page in <AccountingFeatureGate>.
 */

import { createFileRoute } from "@tanstack/react-router";
import { BookOpen } from "lucide-react";
import { AccountingModuleShell } from "@/components/shared/accounting-module-shell";
import { AccountList } from "@/components/accounting/account-list";
import { AccountingFeatureGate } from "@/components/accounting/accounting-feature-gate";

export const Route = createFileRoute(
  "/_authgated/app/$tenantSlug/accounting/accounts/",
)({
  component: AccountsListRoute,
});

function AccountsListRoute() {
  return (
    <AccountingFeatureGate>
      <AccountingModuleShell
        title="Chart of accounts"
        description="System accounts are seeded at tenant creation. Add custom sub-accounts to extend the chart."
        actions={null}
      >
        <div className="mb-2 flex items-center gap-2 text-sm text-muted-foreground sm:hidden">
          <BookOpen aria-hidden className="h-4 w-4" />
          <span>Accounting</span>
        </div>
        <AccountList />
      </AccountingModuleShell>
    </AccountingFeatureGate>
  );
}
